import {Poster, useMediaState} from '@vidstack/react'

import {noop, twMerge} from '@sdox/utils'

import {OverlayButtons} from './Buttons'
import {Center} from '../../Center'

export interface OverlayProps {
  thumbnail?: string
  title?: string
  noControls?: boolean
  handlePlay?: () => void
  isLoading?: boolean
}

const absoluteCenter = 'absolute left-1/2 top-1/2 z-10 -translate-x-1/2 -translate-y-1/2'

export const Overlay = ({
  thumbnail,
  title = '',
  noControls = false,
  handlePlay = noop,
  isLoading =  false,
}: OverlayProps) => {
  const isPaused = useMediaState('paused')

  return (
    <>
      <Poster
        className={
          'absolute inset-0 block size-full object-cover opacity-0 transition-opacity data-[visible]:opacity-100'
        }
        src={thumbnail}
        alt={title}
      />
      <div
        className={twMerge(
          'absolute z-10 size-full cursor-pointer transition-colors ease-in-out',
          'media-paused:bg-scrim-primary/60 media-paused:hover:bg-scrim-primary/60',
          'hover:bg-scrim-primary/20 not-media-playing:bg-scrim-primary/10',
        )}
      >
        {!noControls ? (
          <Center className={absoluteCenter}>
            {isPaused ? (
              <OverlayButtons
                loading={isLoading}
                onClick={handlePlay}
              />
            ) : null}
          </Center>
        ) : null}
      </div>
    </>
  )
}
